import React from "react";
import { ActionItem } from "../../models/SKApplication";
// import { ActionItem, SKApplication, Tier } from "../../models/SKArtifact";

interface ApplicationStateDialogProps {
  action: ActionItem;
  onClose: () => void;
  onUpdate: () => void;
}
interface DiloageContent {
  message: string;
  description: string;
  actionTitle: string;
  destructiv: boolean;
}

// function getDialogeContent(action: ActionItem): DiloageContent | null {
//   switch (action) {
//     case ActionItem.approve:
//       return {
//         message: "Are you sure you will like to Delete this Content?",
//         description: "Content will be permanently deleted form the system and you will not be able to recover it.",
//         actionTitle: "Delete",
//       };

//     case ActionItem.reject:
//       return {
//         message: "Are you sure you will like to Withdraw this content?",
//         description: "You can submit this content for publishing review again.",
//         actionTitle: "Withdraw",
//       };
//     default:
//       return null;
//   }
// }

function getDialogeContent(action: ActionItem): DiloageContent | null {
  switch (action) {
    case ActionItem.approve:
      return {
        message: "Are you sure you will like to Approve Application?",
        description: "This will allow the applicant to continue with channel onboarding.",
        actionTitle: ActionItem.approve,
        destructiv: false,
      };
    case ActionItem.reject:
      return {
        message: "Are you sure you will like to Reject Application?",
        description: "This will stop the applicant from continuing with channel onboarding.",
        actionTitle: ActionItem.reject,
        destructiv: true,
      };

    default:
      return null;
  }
}

const ApplicationStateDialog = ({ action, onClose, onUpdate }: ApplicationStateDialogProps) => {
  let dialogContent = getDialogeContent(action);
  if (!dialogContent) {
    onUpdate();
    return null;
  }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="text-center bg-white rounded-lg shadow-lg w-80">
        <div className="flex flex-col items-center px-6 py-[20px] space-y-2">
          <h2 className="mb-4 text-lg font-semibold">{dialogContent.message}</h2>
          <p className="mb-6 text-sm">{dialogContent.description}</p>
        </div>

        <div className="thickseparator"></div>
        <div className="flex flex-col items-center px-6 py-[20px] space-y-2">
          {!dialogContent.destructiv ? (
            <button className="text-black bg-white popup-button-action" onClick={onUpdate}>
              {dialogContent.actionTitle}
            </button>
          ) : (
            <button className="text-[#FF3B30] bg-white popup-button-action" onClick={onUpdate}>
              {dialogContent.actionTitle}
            </button>
          )}
          <button className="px-4 py-2 text-black bg-white popup-button-action" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationStateDialog;
